var _circle, _rect, _circle2, _rect2, _rect3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 314,
    viewBox: "0 0 314 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.757,
    cy: 118.243,
    r: 80.6097,
    transform: "rotate(-45 195.757 118.243)",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184.541,
    y: 212.557,
    width: 29.6574,
    height: 29.6574,
    transform: "rotate(-90 184.541 212.557)",
    fill: "#F9F9F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.243,
    cy: 195.757,
    r: 80.6097,
    transform: "rotate(-45 118.243 195.757)",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.9644,
    y: 132.89,
    width: 34.5487,
    height: 34.5487,
    transform: "rotate(-90 97.9644 132.89)",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25879_11186",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 90,
    width: 55,
    height: 54
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.9961,
    y: 120.213,
    width: 41.8049,
    height: 33.4439,
    transform: "rotate(-45 89.9961 120.213)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25879_11186)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 195.757,
    cy: 118.243,
    r: 80.6097,
    transform: "rotate(-45 195.757 118.243)",
    stroke: "#4BDACC",
    strokeWidth: 6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.4fac16af78e8357bc1cd619d7270bdfc.svg";
export { ForwardRef as ReactComponent };